//
import axios from 'axios'

//
import TagModel from '@/models/Warehouse/WhTag'

const createTag = async function(data) {
    try {
        console.log('data')
        console.log(data)
        let tag = new TagModel(data)
        let response = await tag.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

/**
 *
 */
const deleteTag = async function(id) {
    //
    try {
        //
        let response = await axios.delete(
            process.env.VUE_APP_API_ROUTE + `/wh_tag/${id}`
        )

        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

const fetchTag = async function(id) {
    try {
        let tag = await TagModel.find(id)
        return tag
    } catch (error) {
        return error.response.data
    }
}

const updateTag = async function(id, data) {
    try {
        let tag = await fetchTag(id)
        tag.tag = data.tag
        tag.description = data.description
        let response = await tag.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const fetchAllTags = async function() {
    try {
        let tag = await TagModel.params({
            get_all_results: true,
        }).get()
        return tag.data
    } catch (error) {
        return error.response.data
    }
}

export default {
    createTag,
    deleteTag,
    fetchTag,
    updateTag,
    fetchAllTags,
    fetchAll: fetchAllTags,
}
